// @flow
import { SuspenseWithPerf } from "reactfire";
import AppHeader from "../../components/AppHeader";
import React from "react";
import ProfileContent from "./ProfileContent";
import Container from "@material-ui/core/Container";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import Helmet from "react-helmet";
import PageHeading from "../../components/PageHeading";

function Profile() {
  return (
    <>
      <Helmet>
        <title>Profil - SG Coesfeld 06</title>
      </Helmet>
      <AppHeader withBorder title="Profil" />
      <Container maxWidth="sm">
        <SuspenseWithPerf traceId="Profile" fallback={<ProfileSkeleton />}>
          <ProfileContent />
        </SuspenseWithPerf>
      </Container>
    </>
  );
}

function ProfileSkeleton() {
  return (
    <>
      <PageHeading>
        <Skeleton />
      </PageHeading>
      <Card>
        <CardContent>
          <Typography color="textSecondary" variant="body2">
            <Skeleton />
            <Skeleton />
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}

export default Profile;
